import { createContext } from 'react';

export const FormControlContext = createContext();

if (process.env.NODE_ENV !== 'production') {
  FormControlContext.displayName = 'FormControlContext';
}
